import React from 'react';

export function phoneVerifiedIcon(phone: undefined | UserPhoneType) {
    if (phone?.two_factor_verified)
        return (
            <i
                className="fa-solid fa-check-circle text-success"
                title="This phone can now be used for 2-step verification when logging in"
            />
        );
    if (phone)
        return (
            <i
                className="fa-solid fa-times-circle text-danger"
                title="This phone can not be used for 2-step verification until it has been verified"
            />
        );
    return null;
}

interface StaticPhoneProps {
    edit: () => void;
    userPhone: undefined | UserPhoneType;
}
export function StaticPhone({ edit, userPhone }: StaticPhoneProps) {
    function buttonText() {
        if (userPhone?.two_factor_verified) return 'Update';
        if (userPhone) return 'Verify';
        return 'Add';
    }

    return (
        <div className="row align-items-center">
            <div className="col-3 text-end">Text Message</div>
            <div className="col-5">
                <span className="me-2">{userPhone?.phone.number || 'None'}</span>
                {phoneVerifiedIcon(userPhone)}
            </div>
            <div className="col-4 text-end text-nowrap">
                <button className="btn btn-primary" onClick={edit} type="button">
                    {buttonText()} Phone
                </button>
            </div>
        </div>
    );
}
